import { EGDSSpacing } from '@egds/react-core/spacing';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { DiscoveryCardContentSize, DiscoveryContainerType, DiscoveryOfferingType, DiscoveryPriceStrategy, DiscoveryRecommendationInputContext, DiscoveryRecommendationStrategy, RecommendationsModule } from '@shared-ui/retail-recommendation-module';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { LineOfBusinessDomain } from '@shared-ui/retail-loyalty-one-key-banner';
import { adaptSearchCriteria } from 'src/common/stores/adapters/bex-api/common/search-criteria-adapter';
import { getShoppingContextInput } from 'src/common/stores/adapters';
import { usePlatformContext } from 'src/common/stores/contexts/platformContext';
import { useSearchCriteriaContext } from 'src/common/stores/contexts';
import CarouselContext from 'src/common/stores/contexts/carousel-context-provider';
import { ConfigurationIdentifiers } from 'src/common/constants/configuration-identifiers';
import { EgRecsPlacementIds } from 'src/common/constants/eg-recs-placements';
import { SharedUiSimilarPropertiesWrapper } from '../shared-ui/details/shared-ui-similar-properties';
import { SimpleLazyLoadWrapper } from '../../common/lazy/simple-lazy-load-wrapper';
export const PropertyBottomCarouselWrapper = inject('currentHotel', 'multiItem')(observer(props => {
  var _a, _b, _c, _d, _e, _f, _g;
  const {
    carouselNames
  } = React.useContext(CarouselContext);
  const context = usePlatformContext();
  const searchCriteria = useSearchCriteriaContext();
  const multiItemContext = (_a = props.multiItem) === null || _a === void 0 ? void 0 : _a.multiItemContext;
  const shoppingContext = getShoppingContextInput(multiItemContext);
  const propertySearchCriteria = adaptSearchCriteria(context, searchCriteria);
  if (carouselNames.topCarousel === 'similar-properties') {
    return null;
  }
  const inputProps = {
    inputs: {
      propertyId: String((_b = props.currentHotel) === null || _b === void 0 ? void 0 : _b.hotelId),
      searchCriteria: propertySearchCriteria,
      shoppingContext
    }
  };
  const {
    checkInDate,
    checkOutDate
  } = (_e = (_d = (_c = inputProps.inputs) === null || _c === void 0 ? void 0 : _c.searchCriteria) === null || _d === void 0 ? void 0 : _d.primary.dateRange) !== null && _e !== void 0 ? _e : {};
  if (!checkInDate || !checkOutDate) {
    return null;
  }
  if (!shoppingContext.multiItem) {
    return React.createElement("div", {
      "data-stid": "property-recs"
    }, React.createElement(EGDSSpacing, {
      margin: {
        small: {
          inline: 'three',
          blockstart: 'six'
        },
        medium: {
          inline: 'unset',
          blockstart: 'six'
        }
      }
    }, React.createElement("div", null, React.createElement(Experiment, {
      name: "SmaSh_Property_Recs_New_Carousel"
    }, React.createElement(ExperimentControl, null, React.createElement(SharedUiSimilarPropertiesWrapper, {
      inputs: inputProps.inputs
    })), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(RecommendationsModule, {
      inputs: {
        configurationIdentifier: ConfigurationIdentifiers.LODGING_DATED_PDP_CAROUSEL_FEATURED_HEADER_CHECK,
        contentSize: DiscoveryCardContentSize.LONG_FORM_FEATURED,
        offeringType: DiscoveryOfferingType.PRODUCT,
        strategy: DiscoveryRecommendationStrategy.ALTERNATIVE,
        containerType: DiscoveryContainerType.CAROUSEL,
        priceStrategy: DiscoveryPriceStrategy.LIVE,
        input: [DiscoveryRecommendationInputContext.PRODUCT],
        recommendationContext: {
          outputLineOfBusiness: LineOfBusinessDomain.LODGING,
          pageId: 'HIS',
          lodging: {
            propertyId: (_f = inputProps.inputs) === null || _f === void 0 ? void 0 : _f.propertyId,
            checkin: checkInDate,
            checkout: checkOutDate
          }
        },
        placementId: EgRecsPlacementIds.PROPERTY_RECS_PLACEMENT_ID
      }
    }))), React.createElement(ExperimentVariant, {
      bucket: 2
    }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(RecommendationsModule, {
      inputs: {
        configurationIdentifier: ConfigurationIdentifiers.LODGING_DATED_PDP_CAROUSEL_NO_FEATURED_HEADER_CHECK,
        contentSize: DiscoveryCardContentSize.LONG_FORM_FEATURED,
        offeringType: DiscoveryOfferingType.PRODUCT,
        strategy: DiscoveryRecommendationStrategy.ALTERNATIVE,
        containerType: DiscoveryContainerType.CAROUSEL,
        priceStrategy: DiscoveryPriceStrategy.LIVE,
        input: [DiscoveryRecommendationInputContext.PRODUCT],
        recommendationContext: {
          outputLineOfBusiness: LineOfBusinessDomain.LODGING,
          pageId: 'HIS',
          lodging: {
            propertyId: (_g = inputProps.inputs) === null || _g === void 0 ? void 0 : _g.propertyId,
            checkin: checkInDate,
            checkout: checkOutDate
          }
        },
        placementId: EgRecsPlacementIds.PROPERTY_RECS_PLACEMENT_ID
      }
    })))))));
  }
  return null;
}));